import React from 'react';
import get from 'lodash/get';
import cs from 'classnames';
import {connect} from 'react-redux';
import pullAllBy from 'lodash/pullAllBy';
import debounce from '~/misc/debounce';


import {MenuListItem} from '~/components/common/MenuList';
import DropDown from '~/components/common/DropDown';
import LabeledInput from '~/components/common/LabeledInput';
import mapDispatch from '~/misc/mapDispatch';
import {
  delectSelectOption,
  createOption,
  multiple_search,
  multiple_set_key,
  multiple_selectPlace,
  multiple_updateCriteria,
  multiple_set_isShow,
  checkSelectInput,
} from '~/modules/geosearch/actions';

import css from './index.css';

const dataQa = (prefix, postfix) => {
  if (!prefix) {
    return null;
  }
  return `geosearch-${prefix}-${postfix}`;
};

// 从array中剔除selected中存在的元素
const eliminateDuplicates = (array, selected) => {
  const lastArray = [];
  selected.forEach(element => {
    if (element.selectedResult !== undefined) {
      lastArray.push(element.selectedResult);
    }
  });
  return pullAllBy(array, lastArray, 'id');
}

const matched = (array) => {
  if (!array || !array.length) {
    return <span/>;
  }
  return array.map((i, num) => (
    <span key={num}
      className={cs(i.isMatched && css.matched)}
      data-qa={i.isMatched ? 'location-matched-string' : null}
    >{i.value}</span>
  ));
};

const itemTitle = (item) => (
  <span className={css.title}>
    <span className={css.mainPart} data-qa='location-main-part'>
      {matched(item.nameParts.main)}
      <span>{item.nameParts.rest.length ? ',' : ''}</span>

    </span>
    <span className={css.restBlock} data-qa='location-rest-part'>
      {item.nameParts.rest.map((part, num) => (
        <span key={num} className={css.restPart}>
          <span>{matched(part)}</span>
          <span>{item.nameParts.rest[num + 1] ? ',' : null}</span>
        </span>
      ))}
    </span>
  </span>
);
class MultipleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.addItem = this.addItem.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.createSelectOptions = this.createSelectOptions.bind(this);
    this.search = debounce((id, value) => this.props.geosearch(value), 200);
    this.list;
    this.state = {
      value: ''
    }
  }

  // 判断this.props.data.selected是否为空，如果是添加一个
  componentWillMount() {
    if (Object.keys(this.props.data).length === 0 || this.props.data.selected.length === 0) {
      this.createSelectOptions();
    }
  }

  componentWillReceiveProps(next) {
    const s = next.data.selected.filter(e => e.isSelect);
    if (s.length > 1) {
      this.setState({value: 'Multiple destinations'})
    } else if (s.length === 0) {
      this.setState({value: ''})
    } else {
      this.setState({value: s[0].placeValue.name})
    }
  }

  render() {
    const prefix = this.props['data-qa'];
    return (
      <div className={cs(this.props.wrapClassName)} data-qa={prefix}>
        <DropDown
          data-qa={dataQa(prefix, 'dropdown')}
          id={this.props.id}
          wrapClassName={css.wrapDropdown}
          dropDownClassName={css.dropdown}
          allowKeyboard={true}
          trigger={
            <LabeledInput
              {...this.props.input}
              data-qa={dataQa(prefix, 'input')}
              icon='position'
              readOnly={true}
              label={this.props.label}
              value={this.state.value}
              placeholder={get(this.props, 'placeholder', 'Anywhere')}
              autoComplete = {this.props.autoComplete}
            />
          }
          content={this.renderSelect()}
          onKeyPress={this.onKeyPress}
        />
      </div>
    );
  }

  renderSelect() {
    const prefix = this.props['data-qa'];
    const data = get(this, 'props.data.search', {});
    const selected = get(this, 'props.data.selected');
    const options = (id) => {
      const array = eliminateDuplicates(get(data, [id, 'list']), selected);
      if (!array || !array.length) {
        return (<span/>);
      }
      return (
        <div className={css.listGroup} data-qa={`georesults-${id}`}>
          {array.map((i, num) => (
            <MenuListItem
              cutText={true}
              data-qa={`suggest-item-${num}`}
              key={i.id}
              data={`${id}:${num}`}
              onMouseDown={this.handleClick}
              title={itemTitle(i)}
            />
          ))}
        </div>
      );
    }

    const optionsGroup = () => (
      <div className={cs(css.optionsGroup)} data-qa={`${prefix}-suggests`}>
        {options('us')}
        {options('ca')}
      </div>
    )

    const menu = (list) => {
      return (
        <div className={cs(css.inputGroup)}>
          {list.map((val, key) => (
            <div className={cs(css.wrapper)} key={key}>
              <div className={cs(css.inputWrapper, {[css.grayInputWrapper]: !val.isSelect})}>
                <img src={!val.isSelect ? "/assets/iocn-place-16.svg" : "/assets/iocn-place-pre.svg"} alt=""/>
                <input
                  type="text"
                  placeholder="Anywhere"
                  value={val.placeValue.name || ''}
                  onChange={this.handleChange}
                  onBlur={() => this.handleBlur(key)}
                  onFocus={() => this.handleFocus(key)}
                  autoFocus={!val.isSelect}
                />
                <img
                src={!val.isSelect ? "/assets/add-a-load-alert-copy-gray.svg" : "/assets/add-a-load-alert-copy-red.svg"}
                onClick={val.isSelect && (() => this.deleteItem(key))}
                />
              </div>
              {val.isShow && this.props.data.criteria && optionsGroup()}
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className={cs(css.list)} data-qa={`${prefix}-suggests`}>
        {this.props.data.selected && menu(this.props.data.selected)}
        {this.props.data.selected && this.props.data.selected.length < 5 && (
          <div className={cs(css.addWrapper)} onClick={this.addItem}>
            <img src="/assets/icon-add.svg" alt=""/>
            <span>ADD DESTINATION</span>
          </div>
        )}
      </div>
    );
  }


  // 初始化数据为空时，添加一个option
  createSelectOptions() {
    this.props.createOption();
  }

  // change事件
  handleChange(event) {
    const value = event.target.value;
    this.props.updateCriteria(value);
    this.search(this.props.id, value);
  }

  // 光标聚焦事件
  handleFocus(key) {
    const value = this.props.data.selected[key].placeValue.name || '';
    this.props.multiple_set_key(key);
    this.props.updateCriteria(value);
    this.search(this.props.id, value);
  }

  // 光标失去焦点事件
  handleBlur(key) {
    this.props.setIsShow(key, false);
    this.props.checkSelectInput(key);
  }

  // 添加
  addItem() {
    const len = this.props.data.selected.length
    if (this.props.data.selected[len - 1].isSelect) {
      this.props.createOption();
    }
  }

  // 在下拉列表中选择
  handleClick(event) {
    const idString = event.currentTarget.getAttribute('data-value');
    this.props.selectPlace(idString);
  }

  // 删除
  deleteItem(key) {
    this.props.delectSelectOption(key);
    if (this.props.data.selected.length === 0) {
      this.props.createOption();
    }
  }

  // this.props.onChange('hahha');
}

export default connect((state, props) => ({
  data: state.geosearch[props.id] || {},
}), mapDispatch({
  // delete
  delectSelectOption: ({id}, key) => delectSelectOption(id, key),
  updateCriteria: ({id}, criteria) => multiple_updateCriteria(id, criteria),
  createOption: ({id}) => createOption(id),
  geosearch: ({id}, value) => multiple_search(id, value),
  multiple_set_key: ({id}, key) => multiple_set_key(id, key),
  selectPlace: ({id}, idString) => {
    const parts = idString.split(':');
    const country = parts[0];
    const num = parts[1];
    return multiple_selectPlace(id, country, num);
  },
  setIsShow: ({id}, key, bol) => multiple_set_isShow(id, key, bol),
  checkSelectInput: ({id}, key) => checkSelectInput(id, key),
}))(MultipleSelect);



// WEBPACK FOOTER //
// ./src/components/common/MultipleSelect/index.js